import axios from '@/libraries/axios/main';
import ApiResponseOld from '@/interfaces/ApiResponseOld';

export async function getAffairs(): Promise<ApiResponseOld> {
  const response = await axios
    .get('/affairs_');

  return response.data as ApiResponseOld;
}

export async function setCurrentAffair(affairNumber: number): Promise<ApiResponseOld> {
  const response = await axios
    .put('/affairs/put/current/' + affairNumber);

  return response.data as ApiResponseOld;
}

export async function getCurrentAffair(): Promise<ApiResponseOld> {
  const response = await axios
    .get('/affairs/get/current');

  return response.data as ApiResponseOld;
}

